import { markRaw } from 'vue'
import LocationsService from 'src/services/locations'

export default {
  find (id) {
    if (id !== null) return LocationsService.fetch(id)
  },
  fetchFiltered (search) {
    this.status = 'loading'
    this.pagination = {}

    const promise = LocationsService.fetchFiltered(search)

    promise
      .then(data => {
        this.locations = data.data
        this.status = 'success'
      })
      .catch(err => {
        console.error(err)
      })

    return promise
  },
  remove (id) {
    this.locations = this.locations.filter(location => location.id !== id)
    this.status = 'success'
  },
  fetchPage (page = 1) {
    const promise = LocationsService.fetchAll(page)

    if (page === 1 && this.locations.length > 0) {
      this.locations = []	
      this.status = 'loading'
    }

    promise
      .then(data => {
        this.locations = this.locations.concat(data.data)
        this.pagination = data.meta.pagination
        this.status = 'success'
      })
      .catch(err => {
        console.error(err)
      })

    return promise
  },
  fetchPaginated (payload = {}) {
    this.status = 'loading'
    const page = payload.page || 1
    if (page === 1 && this.locations.length > 0) {
      this.locations = []
    }

    const promise = LocationsService.fetchPaginated(payload)

    promise
      .then(data => {
        this.locations = Array.isArray(data) ?  [] : this.locations.concat(data.data)
        if (data.data.length > 0) {
           const payload = {
            count: data.to,
            current_page: data.current_page,
            links: [],
            per_page: data.per_page,
            total: data.total,
            total_pages: data.last_page
          }
          this.pagination = payload
        }
        this.status = 'success'
      })
      .catch(err => {
        console.error(err)
      })

    return promise
  },
  fetchGroups () {
    const promise = LocationsService.fetchGroups()

    promise
      .then(groups => this.groups = markRaw(groups))
      .catch(err => console.error(err))

    return promise
  },
  saveGroup (payload) {
    const promise = LocationsService.saveGroup(payload)

    promise
      .then(groups => this.groups = markRaw(groups))
      .catch(err => console.error(err))

    return promise
  },
  updateGroup (payload) {
    const promise = LocationsService.updateGroup(payload)

    promise.catch(err => console.error(err))

    return promise
  },
  deleteGroup (groupId) {
    const promise = LocationsService.deleteGroup(groupId)

    promise
      .then(groups => this.groups = markRaw(groups))
      .catch(err => console.error(err))

    return promise
  },
  reorderGroups (ids) {
    return LocationsService.reorderGroups(ids)
      .then(() => this.fetchGroups())
  },
  fetchLevelSortTypes () {
    const promise = LocationsService.fetchLevelSortTypes()

    promise
      .then(levelSortTypes => { this.levelSortTypes = levelSortTypes })
      .catch(err => console.error(err))

    return promise
  },
  updateGroupLevelSortType (level, sortType) {
    return LocationsService.updateGroupLevelSortType(level, sortType)
      .then(() => Promise.all([this.fetchGroups(), this.fetchLevelSortTypes()]))
  },
  updateList (location) {
    const item = this.locations.find(item => item.id === location.id)
    if (item) Object.assign(item, location)
    else this.locations.unshift(location)
  }
}
